import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  PdfLoader,
  PdfHighlighter,
  Popup,
  Highlight,
  AreaHighlight,
} from "react-pdf-highlighter";
import { Spinner } from "./Spinner";
import { SpinnerModal } from "./SpinnerModal";
import { Sidebar } from "./Sidebar";

import { Row, Col } from "react-bootstrap";

import api from "../../services/api";
import { toast } from "react-toastify";
import { useAuth } from "../../context/auth";

const resetHash = () => {
  document.location.hash = "";
};

// Função para detectar e converter links em texto
const linkifyText = (text) => {
  if (!text) return text;
  
  // Regex para detectar URLs (incluindo http, https, www e domínios simples)
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
  
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      // Garantir que o link tem protocolo
      let url = part;
      if (!part.startsWith('http://') && !part.startsWith('https://')) {
        url = 'https://' + part;
      }
      
      return (
        <a 
          key={index}
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#007bff',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
          onClick={(e) => e.stopPropagation()} // Evitar que o clique no link interfira com outros eventos
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

const HighlightPopup = ({ comment }) =>
  comment.text ? (
    <div className="Highlight__popup">
      {comment.emoji} {linkifyText(comment.text)}
    </div>
  ) : null;

const nomeComp = (tipo, competencia) =>{
  if(competencia == 1){
    return tipo != 1 ? `Competência ${competencia}` : `Modalidade culta da língua`;
  }else if(competencia == 2){
    return tipo != 1 ? `Competência ${competencia}` : `Tipologia textual`;
  }else if(competencia == 3){
    return tipo != 1 ? `Competência ${competencia}` : `Argumentação`;
  }else if(competencia == 4){
    return tipo != 1 ? `Competência ${competencia}` : `Coesão e Estrura do período`;
  }else if(competencia == 5){
    return tipo != 1 ? `Competência ${competencia}` : `Adequação ao tema`;
  }else{
    return 'Observação';
  }
}

const CaixaDadosDeCorrecao = ({ highlight }, tipo) =>
  highlight ? (
    <div key="correcao" className="caixa-correcao">
      <p>
        <strong>{nomeComp(tipo, highlight.competencia)}</strong>
      </p>
      <p>{linkifyText(highlight.comment.text.replace("undefined", ""))}</p>
    </div>
  ) : null;

const CarregarPDFAluno = (props) => {
  const { pdf, preview, setArquivo, id, dadosRedacao } = props;
  const { user } = useAuth();
  
  const isPresencial =
  user?.nivel === "e" && user?.plano === "PRESENCIAL" && !!user?.turma;

  // Estado para as marcações carregadas do servidor
  const [highlights, setHighlights] = useState([]);

  // Estado para controlar se o carregamento inicial foi concluído
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  // Estado para o modal de toque no mobile
  const [modalHighlight, setModalHighlight] = useState(null);
  
  const tipo = dadosRedacao[0]?.tipo ? dadosRedacao[0]?.tipo : 0;
  
  const history = useHistory();

  // Função para carregar correções do servidor (igual ao CarregarPDF)
  async function getCorrecaoNova() {
    try {
      const retorno = await api.get(`/pegar-correcao/${id}`);

      console.log("Carregando correções na tela do aluno:", retorno.data?.length || 0);
      
      if (!retorno.data || retorno.data.length === 0) {
        console.log("Nenhuma correção encontrada para o aluno");
        setHighlights([]);
        // Marcar como concluído mesmo sem correções
        setInitialLoadComplete(true);
        return;
      }

      // NOVO: Processar o novo formato JSON (igual ao CarregarPDF do corretor)
      const valores = retorno.data.map((item) => {
        try {
          // Converter o formato novo para o formato esperado pelo react-pdf-highlighter
          return {
            id: item.id, // ID da correção
            content: {
              image: item.image_url || null,
              // Outros dados que possam ser necessários
            },
            position: {
              boundingRect: {
                x1: item.x1,
                y1: item.y1,
                x2: item.x2,
                y2: item.y2,
                width: item.width || 0,
                height: item.height || 0,
                pageNumber: item.b_rect_page_number || item.page_number || 1,
              },
              rects: item.rects?.rects || [],
              pageNumber: item.page_number || 1,
            },
            comment: {
              text: item.comment || "",
              emoji: item.emoji || "",
            },
            competencia: item.competencia,
            novoSistema: true, // Marcar como novo formato
            id_json: item.id_json, // Preservar o ID original do JSON
          };
        } catch (parseError) {
          console.error("Erro ao processar correção para aluno:", parseError);
          return null;
        }
      }).filter(Boolean);

      console.log(`${valores.length} correções carregadas para visualização do aluno`);
      setHighlights(valores);
      
      // Marcar que o carregamento inicial foi concluído
      setInitialLoadComplete(true);
      
    } catch (err) {
      console.error("Erro ao carregar correções para aluno:", err);
      // Mesmo em caso de erro, marcar como concluído para evitar loops
      setInitialLoadComplete(true);
    }
  }

  useEffect(() => {
    // Carregar correções quando o componente for montado
    if (id) {
      console.log("🏁 Inicializando visualização do aluno - carregando correções");
      getCorrecaoNova();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Toast de sucesso quando carregamento concluído
  useEffect(() => {
    if (initialLoadComplete) {
      toast.dismiss("pronto-visualizacao");
      toast.success(
        "Correções carregadas! Você pode visualizar sua redação corrigida.",
        {
          toastId: "pronto-visualizacao",
          autoClose: 4000,
          position: "top-right",
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialLoadComplete]);

  async function confirmarPDF(id) {
    const retorno = await api.get(`/validarArquivo/${id}`);

    if (retorno.data.message === "Arquivo validado") {
      history.push(`/correcao/${id}`);
    }
    
  }

  async function deletarPDF(pdf) {
    const retorno = await api.get(`/deletarArquivo/${pdf}`);

    if (retorno.data.message === "Arquivo deletado") {
      setArquivo("")
    }
  }

  return (
    <>
      <style>
        {`
          /* CSS mínimo para não interferir no posicionamento - igual ao CarregarPDF */
          .PdfHighlighter {
            width: 100% !important;
          }
          
          .PdfHighlighter canvas {
            max-width: 100% !important;
          }
          
          /* Garantir que as marcações mantenham posição correta */
          .Highlight, .AreaHighlight {
            position: absolute !important;
          }
        `}
      </style>
      
      {/* Overlay centralizado de carregamento estilo modal para aluno */}
      {!initialLoadComplete && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.45)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'all',
          userSelect: 'none',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
            padding: '28px 32px 24px 32px',
            width: '400px',
            maxWidth: '90vw',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{
              fontSize: 20,
              fontWeight: 600,
              color: '#1976d2',
              marginBottom: 10,
              textAlign: 'center',
              letterSpacing: 0.2,
              lineHeight: 1.3,
              wordBreak: 'break-word',
            }}>
              Carregando sua redação corrigida...<br />Aguarde um momento.
            </div>
            <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center', width: '100%' }}>
              <div style={{ transform: 'scale(1.1)' }}><SpinnerModal /></div>
            </div>
          </div>
        </div>
      )}
      
      <Row>
        <Col xs={12} md>
          {/* Só mostra o botão de voltar para classe
            se NÃO estiver em preview e for aluno presencial */}
          {!preview && isPresencial && (
            <p className="text-right">
              <Link
                className="btn btn-success"
                to={`/minhaclasse/${user.turma}`}
              >
                Voltar para minha classe
              </Link>
            </p>
          )}

          {/* Botões de confirmação / reenvio aparecem só no preview,
            independente do plano ser presencial ou IA */}
          {preview && (
            <Row>
              <Col xs={12} lg>
                <p>
                  <button
                    className="btn btn-success"
                    onClick={() => confirmarPDF(id)}
                  >
                    Se o arquivo está correto, por favor CLIQUE AQUI para
                    continuar
                  </button>
                </p>
              </Col>
              <Col xs={12} lg>
                <p>
                  <button
                    className="btn btn-danger"
                    onClick={() => deletarPDF(pdf)}
                  >
                    Caso contrário clique aqui para enviar um novo arquivo
                  </button>
                </p>
              </Col>
            </Row>
          )}

          <div className="App" style={{ display: "flex" }}>
            <div
              style={{
                height: "85vh",
                width: "100%",
                position: "relative",
              }}
            >
              <PdfLoader
                url={`https://redacoes.nyc3.digitaloceanspaces.com/${pdf}`}
                beforeLoad={<Spinner />}
              >
                {(pdfDocument) => (
                  <>
                    <PdfHighlighter
                      pdfDocument={pdfDocument}
                      enableAreaSelection={false}
                      onScrollChange={resetHash}
                      pdfScaleValue="page-width"
                      scrollRef={(scrollTo) => {}}
                      onSelectionFinished={(
                        position,
                        content,
                        hideTipAndSelection,
                        transformSelection
                      ) => (
                        transformSelection(null)
                        
                      )}
                      highlightTransform={(
                        highlight,
                        index,
                        setTip,
                        hideTip,
                        viewportToScaled,
                        screenshot,
                        isScrolledTo
                      ) => {
                        const isTextHighlight = !Boolean(
                          highlight.content && highlight.content.image
                        );

                        const handleTouch = (e) => {
                          e.stopPropagation();
                          if (highlight.comment?.text) {
                            setModalHighlight(highlight);
                          }
                        };

                        const component = isTextHighlight ? (
                          <div onTouchEnd={handleTouch}>
                            <Highlight
                              isScrolledTo={isScrolledTo}
                              position={highlight.position}
                              comment={highlight.comment}
                            />
                          </div>
                        ) : (
                          <div
                            className={`competencia_${highlight.competencia || 'nenhuma'}`}
                            onTouchEnd={handleTouch}
                          >
                            <AreaHighlight
                              isScrolledTo={isScrolledTo}
                              highlight={highlight}
                              onChange={() => null}
                            />
                          </div>
                        );

                        return (
                          <>
                            <Popup
                              popupContent={<HighlightPopup {...highlight} />}
                              onMouseOver={(popupContent) => {
                                CaixaDadosDeCorrecao(highlight, tipo);
                                setTip(highlight, () => popupContent);
                              }}
                              onMouseOut={hideTip}
                              key={index}
                              children={component}
                            />
                          </>
                        );
                      }}
                      highlights={highlights}
                    />
                  </>
                )}
              </PdfLoader>
            </div>
          </div>

          {!preview && (
            <Row>
              <Col>
                <div>
                  <hr />
                  <div className="alert alert-primary" role="alert">
                    <strong>Anotações em seu PDF</strong>
                  </div>
                  <hr />

                  <Sidebar tipo={tipo} highlights={highlights} />
                </div>
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      {/* Modal de toque para mobile */}
      {modalHighlight && (
        <div
          onClick={() => setModalHighlight(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.55)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: '16px',
              width: '100%',
              maxWidth: '480px',
              maxHeight: '80vh',
              overflowY: 'auto',
              padding: '20px 20px 24px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
            }}
          >
            {/* Cabeçalho com competência */}
            <div
              className={`sidebar__highlight competencia_${modalHighlight.competencia}`}
              style={{
                borderRadius: '8px',
                padding: '12px 14px',
                marginBottom: '12px',
              }}
            >
              <strong style={{ fontSize: '15px' }}>
                {modalHighlight.competencia === 0
                  ? 'Salvando informação'
                  : nomeComp(tipo, modalHighlight.competencia)}
                {modalHighlight.comment?.text
                  ? `: ${linkifyText(modalHighlight.comment.text.replace('undefined ', ''))}`
                  : ''}
              </strong>

              {modalHighlight.content?.text && (
                <blockquote style={{ marginTop: '10px', fontSize: '14px', color: '#444' }}>
                  {`${modalHighlight.content.text.slice(0, 90).trim()}…`}
                </blockquote>
              )}

              {modalHighlight.content?.image && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={modalHighlight.content.image}
                    alt="Trecho marcado"
                    style={{ maxWidth: '100%', borderRadius: '6px' }}
                  />
                </div>
              )}
            </div>

            {/* Botão fechar */}
            <button
              onClick={() => setModalHighlight(null)}
              style={{
                width: '100%',
                padding: '12px',
                border: 'none',
                borderRadius: '8px',
                background: '#f0f0f0',
                fontSize: '15px',
                fontWeight: '600',
                color: '#333',
                cursor: 'pointer',
              }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CarregarPDFAluno;
